import React, { useRef } from 'react'
import { LineGraph } from 'blocks.simple/chartGraphs/Line'
import { BarGraph } from 'blocks.simple/chartGraphs/Bar'
import { DoughnutGraph } from '../../../blocks.simple/chartGraphs/Doughunt'
//import { reportMock } from './mockData'
import { useEffect, useState } from 'react'
import moment from 'moment'
import styles from './report_chart.jcss'
import { cn } from 'ethcss'
import { Steps } from '../../../atoms/Steps/Steps-view'
import translate from '../../../core/translate'
import Icon from '../../../blocks.simple/icon/icon'
import { api } from '../../../core/api/ConnectionManager'

function ReportChart({ selectedInfo, params, itemsType }: any) {
    const [report, setReport] = useState<any>(null)
    const [graphType, setGraphType] = useState<string>('lines')
    const [contentKey, setContentKey] = useState<string>(params.length ? params[0] : '')
    const [selectedItem, setSelectedItem] = useState<number | null>(null)
    const [graphData, setGraphData] = useState<any>(null)
    const [doughnutGraphData, setDoughnutGraphData] = useState<any>(null)
    const [isMobile, setIsMobile] = useState<boolean>(false)
    const [hideLeftPanel, setHideLeftPanel] = useState<boolean>(true)
    const [hideRightPanel, setHideRightPanel] = useState<boolean>(true)
    const graphTypes = ['lines', 'bars', 'doughnuts']
    const wrapperRef = useRef<any>(null)

    const checkAvailableItems = () => {
        return report && report.digitalSignages && report.digitalSignages.length
    }

    const getItemsTabs = (items: any) => {
        return items.map((item: any) => {
            return { id: item.id, name: item.name }
        })
    }
    const convertDataToGraph = (selectedItem: any) => {
        if (report === null) return

        const digitalSignage = report.digitalSignages.find((item: any) => item.id === selectedItem)

        if (!digitalSignage) return

        const startDate = moment(report.start)
        const endData = moment(report.end)
        const daysCount = endData.diff(startDate, 'days')
        const labels = [startDate.format('DD.MM.YYYY')]
        const content = digitalSignage.content
        const datasets: any = []

        for (let i = 0; i < daysCount; i++) {
            labels.push(startDate.add(1, 'days').format('DD.MM.YYYY'))
        }

        content.forEach((element: any) => {
            datasets.push({
                label: element.title,
                data: labels.map((label) => {
                    const data: any = element.dataList.find(
                        (item: any) => moment(item.date).format('DD.MM.YYYY') === label
                    )

                    return data ? data[contentKey] : 0
                }),
                borderColor: getRandomColor(),
                backgroundColor: getRandomColor(),
                borderWidth: 1,
            })
        })

        setGraphData({
            labels,
            datasets,
        })
    }


    const convertDataToDoughnutGraph = (selectedItem: any) => {
        if (report === null) return

        const digitalSignage = report.digitalSignages.find((item: any) => item.id === selectedItem)

        if (!digitalSignage) return

        const startDate = moment(report.start)
        const endData = moment(report.end)
        const daysCount = endData.diff(startDate, 'days')
        const labels = [
            {
                date: startDate.format('DD.MM.YYYY'),
                borderColor: getRandomColor(),
                backgroundColor: getRandomColor()
            }
        ]
        const content = digitalSignage.content
        const datasets: any = []

        for (let i = 0; i < daysCount; i++) {
            labels.push({
                date: startDate.add(1, 'days').format('DD.MM.YYYY'),
                borderColor: getRandomColor(),
                backgroundColor: getRandomColor()
            })
        }

        content.forEach((element: any) => {
            datasets.push({
                label: element.title,
                data: labels.map((label) => {
                    const data: any = element.dataList.find(
                        (item: any) => moment(item.date).format('DD.MM.YYYY') === label.date
                    )

                    return data ? data[contentKey] : 0
                }),
                borderColor: labels.map(label => label.borderColor),
                backgroundColor: labels.map(label => label.backgroundColor),
                borderWidth: 1,
            })
        })
        console.log("data", labels, datasets)

        setDoughnutGraphData({
            labels: labels.map(label => label.date),
            datasets,
        })
    }
    const renderGraph = () => {
        switch (graphType) {
            case 'bars':
                return <BarGraph data={graphData} isMobile={isMobile} />
            case 'lines':
                return <LineGraph data={graphData} isMobile={isMobile} />
            case 'doughnuts':
                return <DoughnutGraph data={doughnutGraphData} isMobile={isMobile} />
            default:
                return null
        }
    }

    function getRandomColor() {
        const letters = '0123456789ABCDEF'
        let color = '#'
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)]
        }
        return color
    }

    const checkMobile = () => {
        setIsMobile(window.innerWidth < 700)
    }

    useEffect(() => {
        convertDataToGraph(selectedItem)
        convertDataToDoughnutGraph(selectedItem)
    }, [report, contentKey, selectedItem, graphType])
    useEffect(() => {
        api.send('reportPreview', { id: selectedInfo.id }).then((res: any) => {
            setReport(res)
        })
    }, [])
    useEffect(() => {
        if (checkAvailableItems()) {
            setSelectedItem(report.digitalSignages[0].id)
        }
    }, [report])
    useEffect(() => {
        checkMobile()
        window.addEventListener('resize', checkMobile)

        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    return (
        <div ref={wrapperRef} className={styles.wrapper}>
            {checkAvailableItems() ? (
                <>
                    {isMobile && (
                        <div className={styles.toolbarsTriggers}>
                            <div className={styles.panelTrigger} onClick={() => setHideLeftPanel(!hideLeftPanel)}>
                                <Icon type={hideLeftPanel ? 'display' : 'close'} size={16} />
                            </div>
                            <div className={styles.panelTrigger} onClick={() => setHideRightPanel(!hideRightPanel)}>
                                <Icon type={hideRightPanel ? 'gear' : 'close'} size={16} />
                            </div>
                        </div>
                    )}
                    <div className={cn(styles.leftBlock, isMobile && !hideLeftPanel ? styles.leftBlockOpened : '')}>
                        <div className={styles.leftBlockTitle}>{itemsType}:</div>
                        <div className={styles.leftBlockList}>
                            {getItemsTabs(report.digitalSignages).map((item: any) => {
                                return (
                                    <div
                                        className={cn(
                                            styles.listItem,
                                            selectedItem === item.id ? styles.selectedItem : ''
                                        )}
                                        key={item.digitalSignageId}
                                        onClick={() => setSelectedItem(item.id)}
                                    >
                                        <Icon type={'display'} size={16} />
                                        <span>{item.name}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className={styles.centerBlock}>
                        <Steps className={styles.tabs} active={graphType}>
                            {graphTypes
                                .map((type, index) => {
                                    return (
                                        <button id={type} key={type + index} onClick={() => setGraphType(type)}>
                                            {translate(type)}
                                        </button>
                                    )
                                })
                                .filter((step) => step)}
                        </Steps>
                        {graphData && (
                            <div
                                className={styles.chartWrapper}
                            >
                                {renderGraph()}
                            </div>
                        )}
                    </div>
                    <div className={cn(styles.rightBlock, isMobile && !hideRightPanel ? styles.rightBlockOpened : '')}>
                        <div className={styles.RightBlockTitle}>{translate('showByParameter')}:</div>
                        <div className={styles.paramsList}>
                            {params &&
                                params.map((param: any, index: number) => (
                                    <div
                                        key={param + index}
                                        onClick={() => setContentKey(param)}
                                        className={cn(styles.param, param === contentKey ? styles.selectedParam : '')}
                                    >
                                        {translate(`report_parameter_${param}`)}
                                    </div>
                                ))}
                        </div>
                    </div>
                </>
            ) : (
                <div className={styles.noData}>{translate('noDataToView')}</div>
            )}
        </div>
    )
}

export default ReportChart
